import {
  AvgTimeToDeliverByServiceLevelResponseSchema,
  OMSMetricsRequestSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getAvgTimeToDeliverByServiceLevel = {
  name: "getAvgTimeToDeliverByServiceLevel" as const,
  input: OMSMetricsRequestSchema,
  output: AvgTimeToDeliverByServiceLevelResponseSchema,
};
